export const ImageGalleryPrefixes = {
  LocationAccessModal: 'location-access-modal',
  SettingsPage: 'image-gallery-settings-page',
  ContentComposer: 'image-gallery-content-composer',
};
